

























import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import TextArea from '@/views/atoms/TextArea.vue'
import Global from '@/common/global.js'

export default
  components: {
    Popup
    BlueButton
    CheckBox
    TextArea
  }

  props:
    title:
      type: String
      default: ''
    export_id: 
      type: String
      default: ''
    isPartner:
      type: Boolean
      default: false
    booking:
      type: String
      default: ''
    shipper_name:
      type: String
      default: ''

  data: () ->
    mailaddressList: [],
    postaddress: [],
    afterSumit: false,
    address: '',

  created: () ->
    @getMailaddress()

    api = new ApiClient()
    data = await api.get('/fc/vehicle_information/detail/' + @export_id)
    store.dispatch('setDetailParam', data)

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')

    save_click: () ->
      @afterSumit = true
      param =
        export_id: Number(@export_id)
        comment: store.getters.getPostParam.comment
        mail_list: @postaddress
      api = new ApiClient()
      data = await api.post('/fc/vehicle_information/comment', param)
      if data.errors.length == 0
        store.dispatch('setErrors', [])
        @$emit('click')
      store.dispatch('setErrors', data.errors)
      @afterSumit = false

    addressChange: (e) ->
      @address = e

    click: (e) ->
      @key = e

    addressCheck: (e) ->
      if e
        mailaddress = @postaddress.map (el) -> el.mailaddress
        index = mailaddress.indexOf(@address)
        if index < 0
          @postaddress.push('mailaddress': @address)
      else
        mailaddress = @postaddress.map (el) -> el.mailaddress
        index = mailaddress.indexOf(@address)
        @postaddress.splice(index, 1)
    getMailaddress: () ->
      param = {
        export_id: Number(@export_id)
      }
      api = new ApiClient();
      result = await api.post('fc/mail/list', param)
      list = result.list
      for key in Object.keys(list)
        @mailaddressList.push(list[key])
  }
